import { Box } from "@material-ui/core";

import IsolinesConfigSelector from "./drop-a-pin/IsolinesConfigSelector";
import CloseIcon from "@material-ui/icons/Close";
import { NavLink } from "react-router-dom";
import { IconButton } from "@material-ui/core";
import { setSimulationsVisible } from "store/appSlice";
import { useDispatch, useSelector } from "react-redux";
import { setViewState } from "@carto/react-redux";
import { initialState } from "store/initialStateSlice";

export default function ConfigPanel() {
  const dispatch = useDispatch();
  const visible = useSelector((state) => state.app.simulations.visible);

  function handleVisualization() {
    dispatch(setSimulationsVisible(!visible));
    dispatch(
      setViewState({
        longitude: initialState.viewState.longitude,
        latitude: initialState.viewState.latitude,
        zoom: 12,
        hasFlight: true,
        dragRotate: false,
        pitch: 0,
        transitionDuration: 500,
      })
    );
  }

  return (
    visible && (
      <Box>
        <IconButton
          component={NavLink}
          to="/drop-a-pin"
          onClick={handleVisualization}
        >
          {/* </IconButton><IconButton component={NavLink} to='/' onClick={resetViz }> */}
          <CloseIcon />
        </IconButton>
        <IsolinesConfigSelector />
      </Box>
    )
  );
}
